var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLoan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_loan_euro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_loan_euro"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#9EB0CE",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-53",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6464466,6.64644661 C20.1380712,6.5 20.2630712,6.55596441 20.3535534,6.64644661 C20.4440356,6.73692881 20.5,6.86192881 20.5,7 C20.5,7.13807119 20.4440356,7.26307119 20.3535534,7.35355339 C20.2630712,7.44403559 20.1380712,7.5 20,7.5 C19.8619288,7.5 19.7369288,7.44403559 19.6464466,7.35355339 C19.5559644,7.26307119 19.5,7.13807119 19.5,7 C19.5,6.86192881 19.5559644,6.73692881 19.6464466,6.64644661 Z",
    id: "Rectangle-Copy-4",
    stroke: "#9EB0CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64644661,19.6464466 C7.13807119,19.5 7.26307119,19.5559644 7.35355339,19.6464466 C7.44403559,19.7369288 7.5,19.8619288 7.5,20 C7.5,20.1380712 7.44403559,20.2630712 7.35355339,20.3535534 C7.26307119,20.4440356 7.13807119,20.5 7,20.5 C6.86192881,20.5 6.73692881,20.4440356 6.64644661,20.3535534 C6.55596441,20.2630712 6.5,20.1380712 6.5,20 C6.5,19.8619288 6.55596441,19.7369288 6.64644661,19.6464466 Z",
    id: "Rectangle-Copy-6",
    stroke: "#9EB0CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6464466,19.6464466 C33.1380712,19.5 33.2630712,19.5559644 33.3535534,19.6464466 C33.4440356,19.7369288 33.5,19.8619288 33.5,20 C33.5,20.1380712 33.4440356,20.2630712 33.3535534,20.3535534 C33.2630712,20.4440356 33.1380712,20.5 33,20.5 C32.8619288,20.5 32.7369288,20.4440356 32.6464466,20.3535534 C32.5559644,20.2630712 32.5,20.1380712 32.5,20 C32.5,19.8619288 32.5559644,19.7369288 32.6464466,19.6464466 Z",
    id: "Rectangle-Copy-7",
    stroke: "#9EB0CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6464466,32.6464466 C20.1380712,32.5 20.2630712,32.5559644 20.3535534,32.6464466 C20.4440356,32.7369288 20.5,32.8619288 20.5,33 C20.5,33.1380712 20.4440356,33.2630712 20.3535534,33.3535534 C20.2630712,33.4440356 20.1380712,33.5 20,33.5 C19.8619288,33.5 19.7369288,33.4440356 19.6464466,33.3535534 C19.5559644,33.2630712 19.5,33.1380712 19.5,33 C19.5,32.8619288 19.5559644,32.7369288 19.6464466,32.6464466 Z",
    id: "Rectangle-Copy-5",
    stroke: "#9EB0CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0330351,28.8780893 C23.0252226,28.8780893 23.9978788,28.7609018 24.9510038,28.5265268 L24.6111601,26.077308 C23.8767851,26.327308 23.0838163,26.452308 22.2322538,26.452308 C21.0838163,26.452308 20.1853788,26.1339486 19.5369413,25.4972299 C18.8885038,24.8605111 18.5447538,23.8546518 18.5056913,22.4796518 L22.6306913,22.4796518 L22.6306913,20.8155893 L18.4939726,20.8155893 L18.4939726,19.3155893 L22.6306913,19.3155893 L22.6306913,17.6515268 L18.5174101,17.6515268 C18.5955351,16.3390268 18.9568632,15.3663705 19.6013945,14.733558 C20.2459257,14.1007455 21.1345976,13.7843393 22.2674101,13.7843393 C23.0330351,13.7843393 23.8142851,13.9132455 24.6111601,14.171058 L24.9510038,11.7101205 C23.9431913,11.467933 23.0095976,11.3468393 22.1502226,11.3468393 C20.8767851,11.3468393 19.7517851,11.5851205 18.7752226,12.061683 C17.7986601,12.5382455 17.0232695,13.249183 16.4490507,14.1944955 C15.874832,15.139808 15.5486601,16.2921518 15.4705351,17.6515268 L13.4549101,17.6515268 L13.4549101,19.3155893 L15.4588163,19.3155893 L15.4588163,20.8155893 L13.4549101,20.8155893 L13.4549101,22.4796518 L15.4588163,22.4796518 C15.4978788,23.8624643 15.7986601,25.0343393 16.3611601,25.9952768 C16.9236601,26.9562143 17.6912382,27.6769174 18.6638945,28.1573861 C19.6365507,28.6378549 20.7595976,28.8780893 22.0330351,28.8780893 Z",
    id: "\\u20AC",
    fill: "#9EB0CE",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoan);
export default __webpack_public_path__ + "sanerret-static/media/ic_loan.fb8ea18f049faed189245d9b64e8d84f.svg";
export { ForwardRef as ReactComponent };